import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=8f6e8e22"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports